import { API_ENDPOINTS, ApiResponse } from './api';
import httpClient from './httpClient';

export const dataBinusService = {
  // Existing methods
  getSearchListParticipant: async (params?: { search?: string }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.DATA_BINUS.SEARCHPARTICIPANT,
      {
        params: {
          search: params?.search || ''
        }
      }
    );
    return response.data;
  },

  getSearchListParticipantHC: async (params?: { type: any; businessUnit: any; level: any }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.DATA_BINUS.SEARCHPARTICIPANT_HC,
      {
        params: {
          type: params?.type,
          businessUnit: params?.businessUnit,
          level: params?.level
        }
      }
    );
    return response.data;
  },

  // New methods for Employee data
  getListBU: async () => {
    const response = await httpClient.get<ApiResponse<any>>(API_ENDPOINTS.EMPLOYEE.GET_LIST_BU, {
      params: {
        pageNumber: 1,
        pageSize: 100 // Get a large batch to populate dropdown
      }
    });
    return response.data;
  },

  getListBand: async () => {
    const response = await httpClient.get<ApiResponse<any>>(API_ENDPOINTS.EMPLOYEE.GET_LIST_BAND, {
      params: {
        pageNumber: 1,
        pageSize: 100 // Get a large batch to populate dropdown
      }
    });
    return response.data;
  },

  getListEmployee: async (params: {
    namabu?: string | null;
    namagroupbu?: string | null;
    bandid?: string | null;
    jobFamilyGroupId?: string | null;
    jobFamilyId?: string | null;
  }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.EMPLOYEE.GET_LIST_EMPLOYEE,
      {
        params: {
          pageNumber: 1,
          pageSize: 100,
          namabu: params.namabu || '',
          namagroupbu: params.namagroupbu || '',
          bandid: params.bandid || '',
          jobFamilyGroupId: params.jobFamilyGroupId || '',
          jobFamilyId: params.jobFamilyId || ''
        }
      }
    );
    return response.data;
  },

  // New methods for Job Family data
  getListJobFamilyGroups: async (params?: { search?: string }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.LCMS.COURSES.LCMS_JOB_FAMILY_GROUPS,
      {
        params: {
          pageNumber: 1,
          pageSize: 100,
          search: params?.search || ''
        }
      }
    );
    return response.data;
  },

  getListJobFamilies: async (params: { jobFamilyGroupID: string }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.LCMS.COURSES.LCMS_JOB_FAMILIES,
      {
        params: {
          jobFamilyGroupID: params.jobFamilyGroupID,
          pageNumber: 1,
          pageSize: 100
        }
      }
    );
    return response.data;
  },

  // New methods for Lecturer data
  getListFakultas: async () => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.LECTURER.GET_LIST_FAKULTAS,
      {
        params: {
          pageNumber: 1,
          pageSize: 100 // Get a large batch to populate dropdown
        }
      }
    );
    return response.data;
  },

  getListLevel: async () => {
    const response = await httpClient.get<ApiResponse<any>>(API_ENDPOINTS.LECTURER.GET_LIST_LEVEL, {
      params: {
        pageNumber: 1,
        pageSize: 100 // Get a large batch to populate dropdown
      }
    });
    return response.data;
  },

  getListLecturer: async (params: { akademicGroup?: string | null; jjaId?: string | null }) => {
    const response = await httpClient.get<ApiResponse<any>>(
      API_ENDPOINTS.LECTURER.GET_LIST_LECTURER,
      {
        params: {
          pageNumber: 1,
          pageSize: 100,
          akademicGroup: params.akademicGroup || '',
          jjaId: params.jjaId || ''
        }
      }
    );
    return response.data;
  },

  getRespondentList: async (params: {
    email?: string;
    nama?: string;
    ispeer: boolean;
    isspv: boolean;
    issubordinate: boolean;
    mingrade?: number;
  }) => {
    const response = await httpClient.get(API_ENDPOINTS.DATA_BINUS.RESPONDENT_LIST, {
      params
    });
    return response.data;
  },

  getEmplecList: async (params: { search: string; isEmployee: boolean; isLecturer: boolean }) => {
    const response = await httpClient.get(API_ENDPOINTS.DATA_BINUS.EMPLEC_LIST, {
      params: {
        search: params.search,
        isEmployee: params.isEmployee,
        isLecturer: params.isLecturer
      }
    });
    return response.data;
  }
};
